import React, { Suspense } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import LoadingSpinner from "./component/Error";

// Import CSS
import "./assets/css/meanmenu.css";
import "./assets/css/navber.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/fontawesome.all.min.css";

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <Suspense fallback={<LoadingSpinner />}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </Suspense>
  </React.StrictMode>
);

// Handle both client and server rendering
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
